module.exports = flarum.core.compat['common/components/UserCard'];